/**
 * AccountSitePicker - a <select> of every account, each company followed by
 * its sites (C-02: a contact can be viewed and reassigned between a company
 * and its plants). Companies without sites are plain options; a company with
 * sites becomes a group headed by the company itself.
 */
import { useMemo } from 'react';
import { groupAccountsForPicker } from './crmFormHelpers';

// Defaults as parameters - React 19 ignores defaultProps on function components.
export default function AccountSitePicker({
  accounts = [],
  value = '',
  onChange,
  placeholder = 'Select account or site...',
  style = {},
  title,
}) {
  const groups = useMemo(() => groupAccountsForPicker(accounts), [accounts]);
  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} style={{ appearance: 'auto', ...style }} title={title}>
      <option value="">{placeholder}</option>
      {groups.map(({ company, sites }) =>
        sites.length === 0 ? (
          <option key={company.id} value={company.id}>
            {company.name}
          </option>
        ) : (
          <optgroup key={company.id} label={company.name}>
            <option value={company.id}>{company.name} (company)</option>
            {sites.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name} (site)
              </option>
            ))}
          </optgroup>
        )
      )}
    </select>
  );
}
